import { render, staticRenderFns } from "./BorderedAvatar.vue?vue&type=template&id=f240acfa"
import script from "./BorderedAvatar.vue?vue&type=script&lang=js"
export * from "./BorderedAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports